(function(){
  'use strict';

  var cache={};

  function normalise(value){
    return String(value||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();
  }

  function productPath(card){
    var raw=card.getAttribute('data-product-url')||'';
    if(!raw){
      var link=card.querySelector('a[href*="/products/"]');
      raw=link?link.getAttribute('href')||'':'';
    }
    try{return new URL(raw,location.origin).pathname.replace(/\/$/,'');}
    catch(error){return raw.split('?')[0].replace(/\/$/,'');}
  }

  function getProduct(card){
    var path=productPath(card);
    if(!path) return Promise.resolve(null);
    if(!cache[path]){
      cache[path]=fetch(path+'.js',{headers:{Accept:'application/json'}})
        .then(function(response){return response.ok?response.json():null;})
        .catch(function(){return null;});
    }
    return cache[path];
  }

  function isLightBrassButton(button){
    if(!button) return false;
    var label=button.querySelector('.nv-vc-filter-label');
    var text=normalise(label?label.textContent:button.textContent);
    return text.indexOf('light brass')!==-1||text.indexOf('light brushed brass')!==-1;
  }

  function updateCount(root){
    var visible=Array.prototype.filter.call(root.querySelectorAll('.nv-vc-card'),function(card){
      return !card.classList.contains('is-hidden')&&!card.classList.contains('is-nuvio-category-hidden')&&card.getAttribute('data-nuvio-finish-match')!=='false';
    }).length;
    var count=root.querySelector('[data-nuvio-result-count]');
    if(count) count.textContent=visible+' '+(visible===1?'product':'products')+' shown';
  }

  function revealTitleMatchedProducts(root,button){
    if(!isLightBrassButton(button)) return;
    var tasks=Array.prototype.map.call(root.querySelectorAll('.nv-vc-card'),function(card){
      return getProduct(card).then(function(product){
        if(!product) return;
        var title=normalise(product.title);
        if(title.indexOf('light brushed brass')===-1&&title.indexOf('light brass')===-1) return;
        card.setAttribute('data-nuvio-finish-match','true');
        card.classList.remove('is-hidden');
      });
    });
    Promise.all(tasks).then(function(){updateCount(root);});
  }

  function applyActive(root){
    var button=root.querySelector('.nv-vc-filter.is-active');
    if(!isLightBrassButton(button)) return;
    revealTitleMatchedProducts(root,button);
  }

  function schedule(root,button){
    [80,260,700,1400].forEach(function(delay){
      setTimeout(function(){revealTitleMatchedProducts(root,button||root.querySelector('.nv-vc-filter.is-active'));},delay);
    });
  }

  function bind(root){
    if(root.getAttribute('data-nuvio-light-brass-products-bound')==='true') return;
    root.setAttribute('data-nuvio-light-brass-products-bound','true');
    root.addEventListener('click',function(event){
      var button=event.target.closest&&event.target.closest('.nv-vc-filter');
      if(button&&root.contains(button)) schedule(root,button);
    });
    var grid=root.querySelector('.nv-vc-grid');
    if(grid&&window.MutationObserver){
      var timer=null;
      new MutationObserver(function(){
        clearTimeout(timer);
        timer=setTimeout(function(){applyActive(root);},100);
      }).observe(grid,{childList:true});
    }
  }

  function boot(scope){
    (scope||document).querySelectorAll('.nuvio-variant-collection[data-filter-match-field="variant_title"]').forEach(bind);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();
